import React from 'react';
// styles
import useStyles from '../../../assets/styles/jss/pages/exploreHome/bannerTestingStyle'
import clsx from 'clsx';
//material
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

//assets/images
import ResponsiveContainer from '../../../shared/components/ResponsiveContainer/ResponsiveContainer';
import {Hidden} from '@material-ui/core';

import {eventData, eventTracker} from '../../../shared/components/EventTracker/EventTracker';
import Banner from './Banner';
import moment from "moment";
import { bannersPromotion } from '../../../shared/constants/bannersPromotion';

const BannerTesting = ({onClickLogin, type}) => {
    const classes = useStyles(bannersPromotion[type]);

    const handleToEvent = () => {

        eventData['source'] = 'ExploreHome';
        eventData['NameBanner'] = bannersPromotion[type].btn1.title;
        eventData['LinkBanner'] = bannersPromotion[type].btn1.link;
        eventTracker('Banner', eventData, ['mixpanel']);
    };

    if (type === 2) {
        return <Banner onClickLogin={onClickLogin}/>
    }

    // if (
    //     !(banners[type]?.startDate && banners[type]?.endDate &&
    //         moment().startOf('day').isSameOrAfter(moment(banners[type]?.startDate, 'YYYY-MM-DD').startOf('day')) &&
    //         moment().startOf('day').isSameOrBefore(moment(banners[type]?.endDate, 'YYYY-MM-DD').startOf('day')))
    // ) return <Banner onClickLogin={onClickLogin}/>

    return (
        <Box className={clsx(classes.root, (bannersPromotion[type]?.rootBgLarge && classes.rootBgLarge))}>
            <div className={classes.bgResponsive}></div>
            <Box className={clsx(classes.bgImage)}/>
            <ResponsiveContainer className={classes.responsiveContainer}>
                <Box width={600} display='flex' gridGap={24} flexDirection='column'
                     className={clsx(classes.container, (bannersPromotion[type]?.downTitleImg && classes.downTitleImg))}>
                        {bannersPromotion[type]?.blockImgSecondary && <Box className={classes.blockImgSecondary}>
                        </Box>}
                    {bannersPromotion[type]?.imgSecondary1 && (
                        <Box>
                            <img src={bannersPromotion[type]?.imgSecondary1} className={classes.imgPrimary} style={bannersPromotion[type]?.imgPrimaryStyle|| {}}/>
                        </Box>
                    )}
                    {bannersPromotion[type]?.imgSecondary2 && (
                        <img src={bannersPromotion[type]?.imgSecondary2} className={classes.imgSecondary}/>)}

                    <Box width={'100%'} display='flex' gridGap={24} flexDirection='column'>
                        {bannersPromotion[type]?.desc?.texts.map((desc) => (<Typography variant={desc?.style?.variant}
                                                                               className={`text-${desc?.style?.color}`}
                                                                               align='left'>{desc?.text}</Typography>))}
                    </Box>
                    <Box className={classes.actions}>
                        {
                            bannersPromotion[type].btn1.link
                                ? <Button variant="contained"  className={clsx(bannersPromotion[type].btn1.color && `bg-${bannersPromotion[type].btn1.color}`)} color="primary" href={bannersPromotion[type].btn1.link}
                                          onClick={handleToEvent} target="_blank">{bannersPromotion[type].btn1.title}</Button>

                                : <Button variant="contained" color="primary"
                                          onClick={onClickLogin}>{bannersPromotion[type].btn1.title}</Button>
                        }
                        {bannersPromotion[type]?.btn2 && (
                            <Link href={bannersPromotion[type].btn2.link} target="_blank" underline="hover" color="secondary"
                                  variant="body2" className="semi-bold">{bannersPromotion[type].btn2.title}</Link>)}
                    </Box>
                </Box>
            </ResponsiveContainer>
        </Box>
    )
        ;
};

export default BannerTesting;
